import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { map } from 'rxjs/operators';
import { ClubOverviewService } from '~features/club-overview/club-overview.service';
import { ModulesType, NotificationType } from '~core/enum';
import { FormLabelTranslationService } from '~shared/components/form-fields/translations/form-label-translations.service';
import { Club, Module } from '~core/models';
import { ClubService, DefaultNotificationService } from '~core/services';
import { BasicStatusTranslationService, ClubTranslationsService, ProductSettingsTranslationService } from '~shared/translations';
import { ButtonsTranslations } from '~shared/components/buttons/buttons-translations.service';
import { SpinnerService } from '~shared/components/buttons/spinner/spinner.service';

/**
 * Component that displays the editable data inside of a workspace sidebar and communicates with the Club API
 */
@UntilDestroy()
@Component({
  selector: 'app-tixx-webshop',
  templateUrl: './tixx-webshop.component.html',
  styleUrls: ['../../../../pages/club-settings/club.component.scss']
})
export class TixxWebshopComponent implements OnInit, OnDestroy {
  public clubForm: UntypedFormGroup;
  public spinnerName: 'editTixxWebshop';
  @Input() public selectedClub: Club;

  constructor(
    public clubService: ClubService,
    public clubOverviewService: ClubOverviewService,
    private notificationService: DefaultNotificationService,
    public flTranslations: FormLabelTranslationService,
    public buttonsTranslations: ButtonsTranslations,
    private spinnerService: SpinnerService,
    private clubTranslations: ClubTranslationsService,
    private formBuilder: UntypedFormBuilder,
    private statusTranslations: BasicStatusTranslationService,
    private productTranslations: ProductSettingsTranslationService
  ) { }

  public ngOnInit(): void {
    this.loadData();
  }

  public ngOnDestroy(): void { }

  /**
   * Handles updating of the club-overview. If form is valid submit the form otherwise
   * displays errors.
   */
  public updateClub(): any {
    if (this.clubForm.valid) {
      this.spinnerService.show(this.spinnerName);
      this.clubService.updateModules(this.clubForm.value)
        .pipe(map(res => new Module(res, this.statusTranslations, this.productTranslations)), untilDestroyed(this))
        .subscribe({
          next: (res: Module) => {
            this.spinnerService.hide(this.spinnerName);
            const moduleIndex = this.selectedClub.modules?.findIndex(el => el.name === ModulesType.TIXX_WEBSHOP);
            this.selectedClub.modules[moduleIndex] = res;
            this.clubOverviewService.toggleAllModal(false);
            this.notificationService.showNotification({
              type: NotificationType.SUCCESS,
              message: this.clubTranslations.i18nSuccessClubUpdate
            });
          },
          error: e => {
            this.spinnerService.hide(this.spinnerName);
            this.notificationService.showNotification({
              type: NotificationType.ALERT,
              message: this.clubTranslations.i18nErrorClubUpdate
            });
          }
        });
    }
  }

  /**
   * Fetch the club-overview data via the url parameter and fill the club-overview form.
   */
  public loadData(): void {
    const module = this.selectedClub.modules?.find(el => el.name === ModulesType.TIXX_WEBSHOP);
    this.clubForm = this.formBuilder.group({
      id: [module.id],
      tixxWebshopConfiguration: this.formBuilder.group({
        client: [module['tixxWebshopConfiguration']?.client, [Validators.required]],
      })
    });
  }

}
